import { Controller } from "@hotwired/stimulus";
import intlTelInput, { type Iti } from "intl-tel-input/intlTelInputWithUtils";
import "intl-tel-input/dist/css/intlTelInput.css";

export default class extends Controller {
  static targets = ["input", "value"];

  declare readonly inputTarget: HTMLInputElement;
  declare readonly valueTarget: HTMLInputElement;
  private form?: HTMLFormElement;
  private phoneInput?: Iti;

  connect() {
    this.phoneInput = intlTelInput(this.inputTarget, {
      initialCountry: "us",
      numberDisplayFormat: "NATIONAL",
      separateDialCode: true,
      strictMode: true,
      strictRejectAnimation: true,
    });
    this.form = this.inputTarget.form ?? undefined;
    this.form?.addEventListener("submit", this.sync);
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.sync);
    this.phoneInput?.destroy();
  }

  sync = () => {
    this.valueTarget.value = this.phoneInput?.getNumber() ?? "";
  };
}
